import React from "react";

import { validateEmail } from "src/utils/custom-validations";
import { NeueCanvasButton } from "../components/neue-button/canvas";
import classNames from "classnames";
import { PoweredByDropboxSignLightNeueIcon } from "src/monet/icons";
import { Nullable } from "src/types/nullable.type";
import { NeueJourneyButton } from "../components/neue-button/journey";

type Props = {
    onRecipientAdded: (recipient: { name: string; email: string }) => void;
    recipientName?: string;
    recipientEmail?: string;
}

export const RecipientForm = ({ onRecipientAdded, recipientName: recipientNameInitial, recipientEmail: recipientEmailInitial }: Props) => {
  const [recipientName, setRecipientName] = React.useState(recipientNameInitial || '');
  const [recipientEmail, setRecipientEmail] = React.useState(recipientEmailInitial || '');
  const disabled = !recipientName || !recipientEmail || !validateEmail(recipientEmail); 

  const onSubmit= (e: React.FormEvent) => {
    e.preventDefault();
    onRecipientAdded({ name: recipientName, email: recipientEmail });
  }

  return (
    <form className='flex flex-col gap-4 items-center w-full' onSubmit={onSubmit}>
      <input type='text' className='neue-journey-text-input w-full' placeholder="Name" value={recipientName} onChange={(e) => setRecipientName(e.target.value)} />
      <input type='text' className='neue-journey-text-input w-full' placeholder="Email address" value={recipientEmail} onChange={(e) => setRecipientEmail(e.target.value)} />
      <NeueJourneyButton disabled={disabled} type='submit' className='h-10 w-full'>
        Save
      </NeueJourneyButton>
      <div>
        <PoweredByDropboxSignLightNeueIcon className="w-[160px] text-neue-journey-fg-90" />
      </div>
    </form>
  )
}